<template>
  <div id="app">
    <div class="login_box_all loginbox">
      <div class="login_box_content">
        <div class="text-center login_title login_titleBox">
          《{{ $store.state.Name }}》{{ this.title }}
        </div>
        <div class="login_maxBox">
          <div class="container login_box lookpassword">
            <el-tabs v-model="activeName">
              <el-tab-pane
                label="Retrieve password"
                name="first"
                class="ten"
                title="Retrieve password"
              >
                <el-form
                  ref="form"
                  :model="form"
                  label-width="90px"
                  class="twenfive"
                >
                  <el-form-item :label="texta + 'Email:'">
                    <el-col>
                      <el-input
                        flag="Password"
                        name="phoneAndEmail"
                        type="text"
                        value
                        :placeholder="'Input' + textb + 'Email'"
                        @blur="DetectInput($event, 'phoneAndEmail')"
                        @input="DetectKey($event, 'phoneAndEmail')"
                        v-model="phoneAndEmail"
                        autocomplete="off"
                      ></el-input>
                      <div class="msg_error" v-html="phoneAndEmailTiShi"></div>
                    </el-col>
                  </el-form-item>

                  <el-form-item label="V Code:">
                    <el-col :md="15" :lg="15" :xl="15" :sm="15" :xs="13">
                      <el-input
                        autocomplete="off"
                        flag="Password"
                        name="code"
                        type="text"
                        maxlength="6"
                        placeholder="input V Code"
                        @blur="DetectInput($event, 'code')"
                        @input="DetectKey($event, 'code')"
                        v-model="code"
                      ></el-input>
                    </el-col>
                    <el-col
                      :md="7"
                      :lg="7"
                      :xl="7"
                      :sm="7"
                      :xs="7"
                      class="ml5 onyzm"
                    >
                      <el-button
                        type="primary"
                        plain
                        @click="sendCodeBtn($event)"
                        id="getcode"
                        title="Send verification code"
                        >{{ Btn }}</el-button
                      >
                    </el-col>
                    <div class="clearfix"></div>
                    <div class="msg_error">
                      Please enter 6 verification code
                    </div>
                    <el-alert
                      class="five"
                      title="The verification code has been sent to the designated mailbox, valid for 24 hours"
                      type="warning"
                      v-if="codeTiShi == 0"
                    >
                    </el-alert>
                    <el-alert
                      class="five"
                      title="The verification code has been sent to the designated mobile , valid for 60 seconds"
                      type="warning"
                      v-if="codeTiShi == 2"
                    >
                    </el-alert>
                  </el-form-item>
                  <el-form-item label="Password:" v-if="status == 1">
                    <el-col>
                      <el-input
                        placeholder="Enter a new password"
                        maxlength="16"
                        type="password"
                        @blur="DetectInput($event, 'pwd')"
                        @input="DetectKey($event, 'pwd')"
                        v-model="pwd"
                        autocomplete="off"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="msg_error" v-html="pwdTiShi"></div>
                    <div class="msg_right" v-if="pwdTiShi == ''">
                     The password must be set to 8~16 letters, numbers and special characters .!@#_ Combination
                    </div>
                  </el-form-item>
                  <el-form-item label="Password:" v-if="status == 1">
                    <el-col>
                      <el-input
                        maxlength="16"
                        class="ipt_phone"
                        flag="password"
                        name="repassword"
                        type="password"
                        value
                        placeholder="Enter a new password again"
                        @blur="DetectInput($event, 'rpwd')"
                        @input="DetectKey($event, 'rpwd')"
                        v-model="rpwd"
                        autocomplete="off"
                        show-password
                      ></el-input>
                    </el-col>
                    <div class="msg_error" v-html="rpwdTiShi"></div>
                  </el-form-item>

                  <el-form-item label="">
                    <el-button
                      type="primary"
                      style="width: 100%"
                      @click="forgot"
                      >Confirm</el-button
                    >
                    <div class="clearfix"></div>
                    <div
                      class="leftfloat highgreen"
                      style="margin-left: 3px"
                      v-if="Ispush"
                    >
                      <i class="el-icon-success"></i> Submitted successfully！
                    </div>
                    <div class="rightfloat five">
                      <a href="/" class="highblue">Homepage</a>
                    </div>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <div class="clearfix"></div>
            <div class="login_other fifth">
              <p class="text-center">
                No account? &nbsp;<a
                  href="javascript:void(0)"
                  @click="$router.push('/regist')"
                  >Sign up now</a
                >
              </p>
              <p class="text-center">
                Log in using other methods&nbsp;&nbsp;<a
                  href="javascript:void(0)"
                  @click="$router.push('/')"
                  >Homepage</a
                >
              </p>
              <p class="text-center">
                QQ,WeChat can login directly，No registration required.
              </p>
              <div class="clearfix"></div>
              <div class="login_other_button">
                <!-- <div class="weixin" onclick="this.className = 'weixin on';"> -->
                <el-button
                  v-if="isweixin"
                  type="text"
                  @click="wxshow()"
                  class="weixin"
                  ><img src="../../assets/images/add_wx1.png"
                /></el-button>
                <!-- <a href="javascript:;"><img   @mouseenter="wxshow()" src="../../assets/images/add_wx1.png"></a> -->
                <el-dialog
                  :visible.sync="dialogVisible"
                  width="30%"
                  center
                  :before-close="handleClose"
                >
                  <div v-loading="loading">
                    <p class="mobList eqcode">
                      Long press the identification QR code to register and log
                      in
                    </p>
                    <p class="pclist eqcode">
                      Please use wechat to scan QR code to register and log in
                    </p>
                    <!-- <Login_WeiXin
				 @func="getMsgFormSon" style="display:block;margin:0 auto"
				 @fuab="dialoga"
				 :dialogVisible='dialogVisible'
				 :type="1"
				></Login_WeiXin> -->
                    <div>
                      <img :src="src" width="150" height="150" style="" />
                    </div>
                  </div>
                </el-dialog>
                <!-- <div v-loading="loading" v-if="dialogVisible" style="display:none"  class="mobList">
					<Login_WeiXin
				 @func="getMsgFormSon" style="display:none"
				 @fuab="dialoga"
				 :dialogVisible='dialogVisible'
				 :type="2"
				 class="mobList"
				></Login_WeiXin>
				</div> -->
                <!-- <div class="weixin_nr" v-if="showWx" > -->
                <!-- <img src="../../assets/images/weixin.jpg" width="150" height="150" />
                <Login_WeiXin
				 @func="getMsgFormSon"
				></Login_WeiXin> -->
                <!-- </div> -->
                <a style="cursor: pointer" @click="useqqlogin" class="qq_login"
                  ><img src="../../assets/images/add_qq1.png"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <MasterButtom></MasterButtom>
  </div>
</template>

<script>
var timeStop;
import md5 from "js-md5";
import CryptoJS from "crypto-js";
import Login_WeiXin from "../../components/Login/Login_WeiXin";
import MasterButtom from "../../components/MasterButtom";
export default {
  name: "login",
  data() {
    return {
      showWx: false,
      isweixin: true,
      dialogVisible: false,
      src: "",
      loading: true,
      form: {
        name: "",
        type: "",
        pass: "",
        user: "",
        yzcode: "",
      },
      Ispush: false,
      activeName: "first",
      texta: "",
      textb: "",
      status: 0,
      phoneAndEmail: "",
      code: "",
      Code: "",
      pwd: "",
      rpwd: "",
      phoneAndEmailTiShi: "            ",
      codeTiShi1: "            ",
      pwdTiShi: "            ",
      rpwdTiShi: "            ",
      wait: 60,
      codeTiShi: -1,
      backgroundDiv: {
        backgroundImage:
          "url(" + require("../../assets/images/login_bg.jpg") + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      },
      user_type: "",
      title: "Reset Password",
      Btn: "Send V Code",
    };
  },
  components: {
    Login_WeiXin,
    MasterButtom,
  },

  async mounted() {
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map((item) => {
        if (item.SetItemID == 11) {
          if (item.Item_Value == "是") {
            this.texta = "Phone/";
            this.textb = " phone number or";
          } else {
            this.texta = "";
            this.textb = "";
          }
        }
      });
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
      ];
      this.$store.dispatch("_getSet", params).then((res) => {
        sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
        let SetItem = res.data.Data;
        SetItem.map((item) => {
          if (item.SetItemID == 11) {
            if (item.Item_Value == "是") {
              this.texta = "phone number/";
              this.textb = "phone number or";
            } else {
              this.texta = "";
              this.textb = "";
            }
          }
        });
      });
    }
  },
  methods: {
    async wxshow() {
      this.dialogVisible = true;
      let carousel = await this.$store.dispatch("_getGetQrcode");
      if (carousel) {
        this.src = carousel.data.Url;
        this.Code = carousel.data.Code;
        this.loading = false;
        this.handleQrcodeCheck(this.type);
        this.$emit("func", this.src);
      }
    },
    handleQrcodeCheck(type) {
      timeStop = window.setInterval(() => {
        this.$store
          .dispatch("_getWeiXinLogin", { Scene: this.Code })
          .then((res) => {
            if (res.data.IsSuccess) {
                if (!res.data.Data.IsGo) {
                this.pwdFalseShow = true;
                return;
              }
              this.$message({ message: "Success!", type: "success" });
              localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
              var urldomain = "/";
              window.location.href = urldomain;
              this.$emit("fuab", false);
            }
          });
      }, 2000);
    },
    handleClose(done) {
      done();
      this.dialogVisible = false;
      clearInterval(timeStop);
    },
    //鼠标离开
    DetectInput(elem, type) {
      //焦点离开时候的事件
      if (type == "phoneAndEmail") {
        if (this.$Bai(elem.target.value)) {
          return (this.phoneAndEmailTiShi =
            "input" + this.textb + "Email Login");
        }
        if (this.$Space(elem.target.value)) {
          return (this.phoneAndEmailTiShi =
            this.textb + "Emailbox cannot contain spaces");
        }
        if (
          !this.$base(elem.target.value, "email") &&
          !this.$base(elem.target.value, "phone")
        ) {
          return (this.phoneAndEmailTiShi =
            "Please enter the correct format" + this.textb + "Email");
        } else {
          return (this.phoneAndEmailTiShi = "");
        }
      } else if (type == "code") {
        if (this.$Bai(elem.target.value)) {
          return (this.codeTiShi1 = "verification code must be filled");
        }
        if (this.$Space(elem.target.value)) {
          return (this.codeTiShi1 = "Verification code cannot contain spaces");
        }
        if (elem.target.value.length < 6) {
          return (this.codeTiShi1 = "Please enter  6  verification code");
        } else {
          return (this.codeTiShi1 = "");
        }
      } else if (type == "pwd") {
        if (this.$Bai(elem.target.value)) {
          return (this.pwdTiShi = "password can not be blank");
        } else if (elem.target.value.length < 8) {
          return (this.pwdTiShi =
            "Password cannot be less than eight characters");
        } else if (this.$Space(elem.target.value)) {
          return (this.pwdTiShi = "Password cannot contain spaces");
        } else if (this.$base(elem.target.value, "aff")) {
          return (this.pwdTiShi = "Illegal characters found in password");
        } else if (!this.$base(elem.target.value, "pass")) {
          return (this.pwdTiShi =
            "The password must be set to 8~16 letters, numbers and special characters .!@#_ Combination");
        } else {
          this.pwdTiShi = "";
        }
      } else if (type == "rpwd") {
        if (this.$Bai(elem.target.value)) {
          this.rpwdTiShi = "Password can not be blank";
        } else if (elem.target.value.length < 8) {
          this.rpwdTiShi = "The password must be set to 8~16 letters, numbers and special characters .!@#_ Combination";
        } else if (this.$Space(elem.target.value)) {
          return (this.rpwdTiShi = "Password cannot contain spaces");
        } else if (this.form.pass != this.form.rpass) {
          this.rpwdTiShi = "The two passwords are not the same";
        } else {
          this.rpwdTiShi = "";
        }
      }
    },
    //正在输入时清空错误提示
    DetectKey(elem, type) {
      let base = this.base;
      if (type == "phoneAndEmail") {
        return (this.phoneAndEmailTiShi = "");
      } else if (type == "code") {
        return (this.codeTiShi1 = "");
      } else if (type == "pwd") {
        return (this.pwdTiShi = "");
      } else if (type == "rpwd") {
        return (this.rpwdTiShi = "");
      }
    },
    async sendCodeBtn(elem) {
      console.log(elem);
      //点击发送验证码
      //0: Email 1:用户名 2: 手机
      let Type = -1;
      if (this.$Bai(this.phoneAndEmail)) {
        return alert(this.textb + "E-mail can not be empty");
      } else if (this.$base(this.phoneAndEmail, "phone")) {
        Type = 2;
      } else if (this.$base(this.phoneAndEmail, "email")) {
        Type = 0;
      } else {
        return alert(
          "Your" +
            this.textb +
            " mailbox format is incorrect or contains illegal characters"
        );
      }
      //验证码已经发送2分钟内不能重发送
      if (this.wait != 60) {
        return;
      }
      //验证email和手机是否注册过
      let res = await this.$store.dispatch("_getRegDeteCt", {
        Account: this.phoneAndEmail,
        Type: Type,
      });
      if (res.data.IsSuccess) {
        if (res.data.ItemCount > 0) {
          if (Type == 0) {
            this.user_type = 1;
          } else {
            this.user_type = Type;
          }
          this.$store
            .dispatch("_getRegSendCode", {
              MobileEmail: this.phoneAndEmail,
              CRCeMethod: this.user_type,
              LookforPassword: true,
            })
            .then((res) => {
              if (res.data.IsSuccess) {
                this.codeTiShi = Type;
                this.status = 1;
                this.timeCode(elem.target);
                localStorage.setItem(
                  "forgotStaTime",
                  parseInt(new Date().getTime() / 1000)
                );
                localStorage.setItem("forgotStaTimeType", this.user_type);
                localStorage.setItem(
                  "forgotTemporaryPhoneEmail",
                  this.phoneAndEmail
                );
              }
            });
        } else {
          return alert(
            "Your" +
              this.textb +
              "mailbox has not been registered yet, and the password cannot be retrieved"
          );
        }
      }
    },
    timeCode() {
      //验证码时间定时器
      let time = setInterval(() => {
        if (this.wait == 0) {
          this.Btn = "Resend V Code";
          this.wait = 60;
          clearInterval(time);
        } else {
          this.Btn = "V Code(" + this.wait + ")";
          this.wait--;
        }
      }, 1000);
    },
    forgot(e) {
      //忘记密码  提交
      let status = 0;
      if (this.status == 0) {
        return;
      }
      if (this.$Bai(this.phoneAndEmail)) {
        status = 1;
        this.phoneAndEmailTiShi = this.textb + "email cannot be empty";
      } else if (this.$base(this.phoneAndEmail, "aff")) {
        status = 1;
        this.phoneAndEmailTiShi =
          "Your login information contains illegal characters";
      } else if (
        !this.$base(this.phoneAndEmail, "phone") &&
        !this.$base(this.phoneAndEmail, "email")
      ) {
        status = 1;
        this.phoneAndEmailTiShi =
          "Please enter the correct format" + this.textb + "email";
      }
      if (this.$Bai(this.code)) {
        status = 1;
        this.codeTiShi1 = "verification code must be filled";
      } else if (this.code.length < 6) {
        status = 1;
        this.codeTiShi1 = "Please enter  6  verification code";
      } else if (this.$base(this.code, "aff")) {
        status = 1;
        this.codeTiShi1 = "The verification code contains illegal characters";
      }
      if (this.$Bai(this.pwd)) {
        status = 1;
        this.pwdTiShi = "password can not be blank";
      } else if (this.pwd.length < 8) {
        status = 1;
        this.pwdTiShi = "Password cannot be less than eight characters";
      } else if (this.$Space(this.pwd)) {
        status = 1;
        this.pwdTiShi = "Password cannot contain spaces";
      } else if (this.$base(this.pwd, "aff")) {
        status = 1;
        this.pwdTiShi = "Illegal characters found in password";
      } else if (!this.$base(this.pwd, "pass")) {
        status = 1;
        this.pwdTiShi = "Not less than 8 characters";
      }
      if (this.$Bai(this.rpwd)) {
        status = 1;
        this.rpwdTiShi = "password can not be blank";
      } else if (this.rpwd.length < 8) {
        status = 1;
        this.rpwdTiShi = "Password cannot be less than eight characters";
      } else if (this.$Space(this.rpwd)) {
        status = 1;
        this.rpwdTiShi = "Password cannot contain spaces";
      } else if (this.$base(this.rpwd, "aff")) {
        status = 1;
        this.rpwdTiShi = "Illegal characters found in password";
      } else if (this.pwd != this.rpwd) {
        status = 1;
        this.rpwdTiShi = "The two passwords are not the same";
      }
      if (status == 1) {
        return;
      }
      let pwm = md5(this.pwd + "!@*Samson*@!");
      let pwaes = CryptoJS.AES.encrypt(this.pwd, pwm).toString();
      var data = {
        EmailMobile: this.phoneAndEmail,
        NewPassword: pwaes,
        Type: this.user_type,
        CRC: this.code,
        Npwm: pwm,
      };
      this.$store.dispatch("_getForgetPassword", data).then((res) => {
        if (res.data.IsSuccess) {
          sessionStorage.setItem("text", 1);
          this.$message({
            showClose: true,
            message: "Retrieve the password successfully, jumping·······",
            type: "success",
          });
          this.$router.push("/Login");
        } else {
          return alert(this.$CHEn.CH_EN(res.data.Message));
        }
      });
    },
    //点击QQ登录
    // tz() {
    //   	var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101866331&response_type=token&scope=all&redirect_uri=http%3A%2F%2F2020test.notefirst.com%2F#%2Flogin_qq";
    //   	window.location.href = urldz;
    // },
    useqqlogin() {
      var urldz =
        "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=" +
        window.OpenId +
        "&response_type=token&scope=all&redirect_uri=http%3A%2F%2F" +
        window.callBackHtp +
        "%2F%23%2Flogin_qq";
      window.location.href = urldz;
    },
  },
};
</script>

<style scoped>
.el-button--primary.is-plain {
  color: #fff;
}
.login_box .el-tabs__item {
  width: 150px !important;
}
</style>
